module.exports = __webpack_public_path__ + "static/media/read_circle.beeec376.png";